import { cn } from "@/utils/functions";
import { DeleteOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import usePermissions from "@/utils/usePermissions";

export default function CommonDelete({
  title,
  deleteThunk,
  id,
  values,
  navigatePath,
  permission,
  className,
  loadThunk,
  query,
  icon,
  onSuccess,
  button,
  confirmMessage,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { permissions } = usePermissions();
  const { t } = useTranslation();

  const handleAction = async () => {
    const res = await dispatch(deleteThunk(id ? { id } : values));
    if (res.payload?.message === "success" || (res.data && !res.error)) {
      loadThunk && dispatch(loadThunk(query && query));
      onSuccess && onSuccess();
      navigatePath && navigate(navigatePath);
    }
  };

  const onDelete = async () => {
    const hasPermission = permissions?.includes(permission);
    if (!hasPermission) {
      toast.error(t("common.permissionError"));
      return;
    }

    Modal.confirm({
      title: title || t("common.delete"),
      content: confirmMessage
        ? confirmMessage
        : t("common.areYouSure", {
            action: t("common.deleteAction") || "Delete",
          }),
      okText: t("common.yes") || "Yes",
      okType: "danger",
      cancelText: t("common.no") || "No",
      onOk: handleAction,
    });
  };
  return (
    <>
      {!button && (
        <>
          {icon ? (
            <div onClick={(e) => { e.stopPropagation(); onDelete(); }} className="flex items-center gap-2">
              <span className="cursor-pointer">{icon}</span>
              {title || null}
            </div>
          ) : (
            <div
              onClick={(e) => { e.stopPropagation(); onDelete(); }}
              className={`flex items-center gap-2 group hover:text-red-500`}>
                <DeleteOutlined
                  className={cn(
                    ` inline-block rounded-md group-hover:text-red-500`,
                    {
                      [className]: className,
                    }
                  )}
                />
              {title || t("common.delete")}
            </div>
          )}
        </>
      )}

      {button && (
        <div className="cursor-pointer" onClick={(e) => { e.stopPropagation(); onDelete(); }}>
          {button}
        </div>
      )}
    </>
  );
}
